import { Box, Theme } from "@outschool/backpack";
import {
  ActivityListing_ListingFragment,
  SearchActivityListingsByActivityUidsQueryVariables,
  SearchActivityListingsByActivityUidsQuery as SearchListingsByActivityUidsQueryType
} from "@outschool/gql-frontend-generated";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";
import { useSession } from "@outschool/ui-auth";
import {
  ActivityListing,
  ActivityListingFragment
} from "@outschool/ui-components-website";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import { CARD_WIDTH } from "../listings/constants";
import { SearchListingSkeleton } from "./SearchListingSkeleton";
import { useSingleAdClassSearchExperiment } from "./useSingleAdClassSearchExperiment";

export const SearchActivityListingsByActivityUidsQuery = gql`
  query SearchActivityListingsByActivityUids(
    $activityUids: [ID!]!
    $skipRating: Boolean!
  ) {
    listingsByActivityUids(activityUids: $activityUids) {
      ...ActivityListing_listing
    }
  }
  ${ActivityListingFragment}
`;

export const TopActivityList = () => {
  const { isSingleAdClassTreatment, activityUid } =
    useSingleAdClassSearchExperiment();

  const isMobile = useIsMobile();
  const { isLoggedIn } = useSession();

  const { data, loading, error } = useQueryWithPreviousData<
    SearchListingsByActivityUidsQueryType,
    SearchActivityListingsByActivityUidsQueryVariables
  >(SearchActivityListingsByActivityUidsQuery, {
    skip: !isSingleAdClassTreatment || !activityUid,
    variables: {
      activityUids: [activityUid],
      skipRating: false
    }
  });

  if (error) {
    OsPlatform.captureMessage(
      `Error fetching listings by activity uid ${activityUid} on search page`
    );
    return null;
  }

  if (!isSingleAdClassTreatment) {
    return null;
  }

  return loading ? (
    <SearchListingSkeleton />
  ) : data?.listingsByActivityUids?.length ? (
    <Box
      sx={(theme: Theme) => ({
        gridTemplateColumns: `repeat(auto-fill, minmax(${CARD_WIDTH}px, 1fr))`,
        [theme.breakpoints.up("md")]: {
          justifyItems: "center"
        }
      })}
    >
      {data.listingsByActivityUids.map(
        (listing: ActivityListing_ListingFragment) => (
          <Box key={listing.activity.uid}>
            <ActivityListing
              listing={listing}
              openInSSRForLoggedOutUsers={!isLoggedIn}
              pageLocation={isMobile ? "MOBILE_LISTING" : "DESKTOP_LISTING"}
            />
          </Box>
        )
      )}
    </Box>
  ) : null;
};
